export default "__VITE_ASSET__DPNwEV8F__"